import React, { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Stats,
  Gallery,
  SpacerV,
  FeatureCard,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import Lottie from "react-lottie";

export default function Kubernetes() {
  useEffect(() => {}, []);

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />

        <Hero
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          title="Why Hire Us for Kubernetes?"
          subtitle={
            <div>
              <p>
                Our Kubernetes expertise ensures seamless container
                orchestration, scalability, and optimized infrastructure
                management. Here’s why we’re the right choice for your business:
              </p>
              {!state.auth.isMobile ? (
                <ul>
                  <li>
                    <strong>Efficient Container Management</strong>: We design
                    and implement Kubernetes clusters to streamline deployment,
                    scaling, and operations.
                  </li>
                  <li>
                    <strong>High Availability & Resilience</strong>: Our
                    solutions ensure auto-scaling, self-healing capabilities,
                    and robust workload distribution for maximum uptime.
                  </li>
                  <li>
                    <strong>Security & Compliance</strong>: We integrate
                    best-in-class security practices, role-based access control
                    (RBAC), and automated policy enforcement.
                  </li>
                </ul>
              ) : (
                ""
              )}
              <p>
                By hiring us, you gain a partner dedicated to delivering
                scalable, secure, and high-performing Kubernetes-based solutions
                tailored to your needs.
              </p>
            </div>
          }
        />

        <ContentSideBySideInv
          title="Top Reasons to Avail Kubernetes Services"
          subtitle={
            <div style={{ marginLeft: "15px" }}>
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
                Scalability
              </div>
              Kubernetes automatically adjusts the number of containers based on demand, ensuring optimal resource utilization.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                Resilience and Self-Healing{" "}
              </div>
              Kubernetes can automatically restart or replace failed containers, maintaining system stability and minimizing downtime.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
                Automated Deployment and Rollbacks
              </div>
              Kubernetes simplifies updates with automated rollouts and rollbacks, 
              reducing disruptions and ensuring smooth transitions between versions.
            </div>
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/marketing (3).json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        <SpacerV height={"100px"} />
        {!state.auth.isMobile ? (
          <div
            style={{
              margin: "100px",
              height: "140vh",
              width: "85vw",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundImage: "url(" + require("../img/kubecon.gif") + ")",
            }}
          ></div>
        ) : (
          ""
        )}
        <SpacerV height={"100px"} />

        <ThreeSideBySide
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          spacing={5}
          subtitle1={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"ClusterIP"}
                text={
                  "The default Kubernetes service type, ClusterIP, exposes a service within the cluster. It assigns an internal IP address, making it accessible only to other services or pods in the same cluster. Ideal for internal communication, ClusterIP simplifies service discovery using DNS without exposing the application to external traffic for your website."
                }
                icon={
                  <TravelExploreIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"NodePort"}
                text={`NodePort makes a service accessible externally by opening a specific port on each node in the cluster. This allows external traffic to be forwarded to the targeted service. NodePort is commonly used for testing or exposing a service directly, but it has limited scalability and lacks advanced load balancing.`}
                icon={
                  <BlurOnIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle2={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"LoadBalancer"}
                text={`LoadBalancer automatically provisions an external load balancer for a service in supported cloud environments. It routes traffic to pods across nodes, providing scalability and fault tolerance. LoadBalancer simplifies external access by combining load distribution and high availability, making it suitable for production workloads.`}
                icon={
                  <DvrIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"ExternalName"}
                text={`The ExternalName service maps a service name to an external DNS address. Instead of providing cluster resources, it acts as a DNS alias for an external endpoint. This is helpful for integrating external services into the cluster without managing endpoints manually, ensuring seamless interaction with external dependencies.`}
                icon={
                  <TabIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle3={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"Headless Service"}
                text={`Headless services (ClusterIP set to None) allow direct pod access without load balancing. Useful for stateful applications like databases, they enable precise pod communication by exposing individual pod IPs. This service facilitates custom discovery mechanisms for workloads requiring specific pod-to-pod communication.`}
                icon={
                  <WindowIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"Ingress (via Service)"}
                text={`Though not a service type itself, Ingress works with services to route HTTP and HTTPS traffic. It uses a single IP to expose multiple services via paths or hostnames. Combined with a ClusterIP or NodePort backend, Ingress simplifies external traffic management and enables features like TLS termination.`}
                icon={
                  <DoubleArrowIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
        />
        <div style={{ height: "100px" }}></div>

        <Stats />
        <div style={{ height: "100px" }}></div>

        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
